
define(
	'Tavano.QAndA.QAndA'
,   [
		'Questions.View'
	,	'QuestionsCounter.View'
	]
,   function (
        QuestionsView
	,	QuestionsCounterView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var self = this;
			var layout = container.getLayout('Layout');
			var pdp = container.getComponent('PDP');
			var userProfile = container.getComponent('UserProfile');

			//Q&A - Add as Registered View
			pdp.registerView('QuestionsAnswersCounter', function() {
				return new QuestionsCounterView({
					application: container,
					options: pdp,
					item: pdp.getItemInfo()
				});
			});

			//Get If User is Logged In
			var getUserProfile = userProfile.getUserProfile().then(function(profile) {
			    
				var isLoggedIn = profile.isloggedin;
				var internalId = profile.internalid;

			});
		
			if(pdp)
			{
				//Get If User is Logged In
				userProfile.getUserProfile().then(function(profile) {

					//Q&A Section - Add as Registered View
					pdp.registerView('QuestionsAnswers', function() {
						return new QuestionsView({
							application: container,
							options: pdp,
							item: pdp.getItemInfo(),
							isLoggedIn: profile.isloggedin,
							internalId: profile.internalid
						});
					});

				});
			}

		}
	};
});
